import React from 'react';
// Data
import {
  tourPageAdditionalMeta,
  tourPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import TourPageMainContainer from '../../components/tour/TourPageMainContainer';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
import FooterComponent from '../../components/footer/FooterComponent';

function TourPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Tour'
        desc='Discover Mistress Maria’s upcoming tour dates and exclusive in-person sessions. Book your chance to experience her powerful presence live.'
        keywords='Mistress Maria, tour dates, in-person sessions, BDSM tour, kink events, booking, domination, UK, exclusive sessions'
        additionalMeta={tourPageAdditionalMeta}
        structuredData={tourPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'Tour Schedule'} />
          </header>
        </div>

        {/* Main page content */}
        <TourPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default TourPage;
